import useSWR from "swr";

import { resourceEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

import { DistinctResourcesMetadataValuesResponse } from "../models";

export function useGetDistinctResourcesMetadataValues(metadataKey: string) {
  let url = resourceEndpoints.getResourcesMetadataDistinctValues();

  if (metadataKey) {
    url += `?key=${metadataKey}`;
  }

  const fetcherWithToken = (url: string) =>
    fetcher<DistinctResourcesMetadataValuesResponse>(url);

  const { data, error, isLoading } = useSWR(url, fetcherWithToken);

  return {
    data,
    isLoading,
    error
  };
}
